module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"viewContract":"Sopimusehdot ja hinnasto","contractTerms":"sopimusehdot ja hinnasto"},"se":{"viewContract":"Avtalsvillkor och prislista","contractTerms":"avtalsvillkoren och prislistan"},"en":{"viewContract":"Terms of service and price list","contractTerms":"terms of service and price list"}}')
  delete Component.options._Ctor
}
